import { render, staticRenderFns } from "./PromotionCashbackTag.vue?vue&type=template&id=1f882bb9&scoped=true"
import script from "./PromotionCashbackTag.vue?vue&type=script&lang=js"
export * from "./PromotionCashbackTag.vue?vue&type=script&lang=js"
import style0 from "./PromotionCashbackTag.vue?vue&type=style&index=0&id=1f882bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f882bb9",
  null
  
)

export default component.exports